<app-button variant="basic" (click)="downloadCSV()">
  <app-icon icon="download" />
</app-button>
